export default "__VITE_ASSET__BQf$MGdN__"